import queryString from "query-string";

export const SEARCH_PATH = "/search";
export const SEARCH_QUERY_KEY = "q";
export const SEARCH_PAGE_SIZE = 7;

export const getSearchTermFromLocation = (location) => {
  if (!location) return "";

  const parsed = queryString.parse(location.search || "");
  const term = parsed[SEARCH_QUERY_KEY];

  return typeof term === "string" ? term.trim() : "";
};

export const buildSearchUrl = (term) => {
  const trimmed = (term || "").trim();
  if (!trimmed) return SEARCH_PATH;
  return `${SEARCH_PATH}?${SEARCH_QUERY_KEY}=${encodeURIComponent(trimmed)}`;
};

export const buildSearchFilter = (searchString) => ({
  authorIds: [],
  educationOnly: false,
  searchString: searchString || "",
  applySearchStringTo: {
    title: true,
    content: true,
    excerpt: true,
    tags: true,
  },
});
